export const RelevoMark = ({ size = "1em", bottomDot = "#1E3A5F", style = {} }) => (
  <svg viewBox="0 0 100 100" style={{ width: size, height: size, ...style }} aria-hidden="true">
    {/* lados translúcidos del triángulo invertido */}
    <line x1="26" y1="24" x2="74" y2="24" stroke="#EDD9AE" strokeWidth="17" strokeLinecap="round" opacity="0.75" />
    <line x1="26" y1="24" x2="50" y2="80" stroke="#9FB4C4" strokeWidth="17" strokeLinecap="round" opacity="0.55" />
    <line x1="74" y1="24" x2="50" y2="80" stroke="#F2955C" strokeWidth="17" strokeLinecap="round" opacity="0.65" />
    {/* vértices */}
    <circle cx="26" cy="24" r="13" fill="#E8B54B" />
    <circle cx="74" cy="24" r="13" fill="#E8701A" />
    <circle cx="50" cy="80" r="13" fill={bottomDot} />
  </svg>
);

export const RelevoLogo = ({ variant = "dark", className = "", style = {} }) => {
  const textColor = variant === "dark" ? "#1E3A5F" : "#FFFFFF";
  const bottomDot = variant === "dark" ? "#1E3A5F" : "#F8FAFC";
  return (
    <span
      className={`inline-flex items-center select-none uppercase ${className}`}
      style={{
        fontFamily: "'Montserrat', system-ui, sans-serif",
        fontWeight: 500,
        letterSpacing: "0.14em",
        color: textColor,
        lineHeight: 1,
        ...style,
      }}
      aria-label="RELEVO"
    >
      RELE
      <RelevoMark size="1.04em" style={{ margin: "0 0.05em", transform: "translateY(0.05em)" }} bottomDot={bottomDot} />
      O
    </span>
  );
};
